var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTextColor = function SvgTextColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M25.567 30.538H6.459a2.46 2.46 0 0 1 0-4.918h19.107a2.46 2.46 0 0 1 0 4.918z",
    style: {
      fill: "var(--bar-color, blue)",
      stroke: "currentColor"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.332 7.3-.654-2.349a.7.7 0 0 0-.675-.512H9.997a.7.7 0 0 0-.674.512l-.654 2.35a.7.7 0 1 0 1.348.375l.512-1.836h4.805v13.543H13.27a.7.7 0 1 0 0 1.4h5.596a.7.7 0 1 0 0-1.4h-2.131V5.84h4.738l.511 1.836a.7.7 0 0 0 1.35-.376z"
  })));
};
export default SvgTextColor;